module.exports = __webpack_public_path__ + "assets/img/get-it-on-google-play.80f91715.png";